import { ReactNode } from "react"
import { usePage } from "@inertiajs/react"
import DashboardTopbar from "@/components/DashboardTopbar"
import ActionBar from "@/components/player/ActionBar"
import GamesList from "@/components/player/GamesList"
import AppLayout from "@/layouts/AppLayout"
import useUser from "@/hooks/useUser"
import { PlayerShowProps } from "@/types/types"
import EditPlayerModal from "@/modals/EditPlayerModal"
import ShareModal from "@/modals/ShareModal"
import DeletePlayerModal from "@/modals/DeletePlayerModal"
import { UserIcon } from "@heroicons/react/20/solid"

const PlayerShowPage = () => {
  const { player, isOwner } = usePage<PlayerShowProps>().props
  const { user } = useUser()
  const isMe = player.id === user?.player_id

  return (
    <>
      <DashboardTopbar
        title={player.name}
        badge={isMe ? "You" : undefined}
      >
        {isOwner && <ActionBar player={player} />}
      </DashboardTopbar>

      {player.linked_profile && (
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-3 sm:px-6">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <UserIcon className="text-chessdrop-600 size-4 shrink-0" />
            <span className="font-medium">ChessDrop profile:</span>
            <span>{player.linked_profile.name}</span>
            {player.linked_profile.title && (
              <span className="rounded bg-gray-200 px-1.5 py-0.5 text-xs font-medium text-gray-700">
                {player.linked_profile.title}
              </span>
            )}
            {player.linked_profile.elo && (
              <span className="text-gray-500">({player.linked_profile.elo})</span>
            )}
            {player.linked_profile.fide_id && (
              <a
                href={`https://ratings.fide.com/profile/${player.linked_profile.fide_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-chessdrop-600 hover:text-chessdrop-700 hover:underline"
              >
                FIDE Profile
              </a>
            )}
          </div>
        </div>
      )}

      <main>
        <GamesList games={player.games} />
      </main>

      {isOwner && (
        <>
          <EditPlayerModal player={player} />
          <DeletePlayerModal player={player} />
          <ShareModal
            title="Share player"
            url={`https://chessdrop.com/players/${player.id}`}
            type="player"
          />
        </>
      )}
    </>
  )
}

export default PlayerShowPage

PlayerShowPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
